/* Jamal Al Muhra — wishlist (localStorage, no app required).
   Hearts on cards + PDP, header count, /pages/wishlist renderer. */
(function () {
  var KEY = 'jam_wishlist';
  var syncQueued = false;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {}
    sync();
  }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    return i === -1;
  }

  function sync() {
    var list = read();
    document.querySelectorAll('[data-jam-wish]').forEach(function (b) {
      var wished = list.indexOf(b.dataset.handle) > -1;
      b.classList.toggle('is-wished', wished);
      b.setAttribute('aria-pressed', wished ? 'true' : 'false');
    });
    document.querySelectorAll('[data-jam-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = !list.length;
    });
  }
  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync(); });
  }

  /* wishlist is for account holders — guests get a sign-in prompt */
  function localeRoot() {
    return document.documentElement.lang === 'ar' ? '/ar' : '';
  }
  function authPrompt() {
    var existing = document.querySelector('.jam-auth-pop');
    if (existing) { existing.hidden = false; return; }
    var ar = document.documentElement.lang === 'ar';
    var root = localeRoot();
    var pop = document.createElement('div');
    pop.className = 'jam-auth-pop';
    var card = document.createElement('div');
    card.className = 'jam-auth-pop__card';
    var h = document.createElement('h3');
    h.textContent = ar ? 'سجّل الدخول لحفظ مفضلتك' : 'Sign in to save your wishlist';
    var p = document.createElement('p');
    p.textContent = ar
      ? 'أنشئ حساباً أو سجّل الدخول لتبقى القطع التي أحببتها بانتظارك.'
      : 'Create an account or sign in, and the pieces you love will be waiting for you.';
    var row = document.createElement('div');
    row.className = 'jam-auth-pop__row';
    var login = document.createElement('a');
    login.className = 'button button--primary';
    login.href = root + '/account/login';
    login.textContent = ar ? 'تسجيل الدخول' : 'Sign in';
    var reg = document.createElement('a');
    reg.className = 'button button--secondary';
    reg.href = root + '/account/register';
    reg.textContent = ar ? 'إنشاء حساب' : 'Create account';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'jam-auth-pop__close';
    close.setAttribute('aria-label', ar ? 'إغلاق' : 'Close');
    close.textContent = '\u00d7';
    close.addEventListener('click', function () { pop.hidden = true; });
    pop.addEventListener('click', function (e) { if (e.target === pop) pop.hidden = true; });
    row.appendChild(login); row.appendChild(reg);
    card.appendChild(close); card.appendChild(h); card.appendChild(p); card.appendChild(row);
    pop.appendChild(card);
    document.body.appendChild(pop);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-jam-wish-link]');
    if (link && !window.jamCustomer) { e.preventDefault(); authPrompt(); return; }
    var b = e.target.closest && e.target.closest('[data-jam-wish]');
    if (!b) return;
    e.preventDefault();
    if (!window.jamCustomer) { authPrompt(); return; }
    toggle(b.dataset.handle);
    if (b.dataset.remove === 'true') {
      var card = b.closest('[data-jam-wish-card]');
      if (card) card.remove();
      renderEmptyIfNeeded();
    }
  });

  /* keep hearts correct when sections re-render via innerHTML */
  new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', sync);

  /* ---- wishlist page ---- */
  function renderEmptyIfNeeded() {
    var page = document.querySelector('[data-jam-wish-page]');
    if (!page) return;
    if (!page.querySelector('[data-jam-wish-card]')) {
      page.querySelector('[data-jam-wish-empty]').hidden = false;
    }
  }

  function money(cents, currency, locale) {
    var amount = (cents / 100).toLocaleString(locale === 'ar' ? 'ar-AE' : 'en-GB',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var code = currency || 'AED';
    return amount + ' ' + code;
  }

  function renderPage() {
    if (!window.jamCustomer) return;
    var page = document.querySelector('[data-jam-wish-page]');
    if (!page) return;
    var grid = page.querySelector('[data-jam-wish-grid]');
    var list = read();
    if (!list.length) { page.querySelector('[data-jam-wish-empty]').hidden = false; return; }
    var root = (page.dataset.localeRoot || '').replace(/\/$/, '');
    var locale = root === '/ar' ? 'ar' : 'en';
    list.forEach(function (handle) {
      fetch(root + '/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var url = root + '/products/' + handle;
          var el = document.createElement('div');
          el.className = 'jam-wishpage__card';
          el.setAttribute('data-jam-wish-card', '');

          var media = document.createElement('a');
          media.className = 'jam-wishpage__media';
          media.href = url;
          if (p.featured_image) {
            var img = document.createElement('img');
            img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=480';
            img.alt = '';
            img.loading = 'lazy';
            media.appendChild(img);
          }

          var title = document.createElement('a');
          title.className = 'jam-wishpage__title';
          title.href = url;
          title.textContent = p.title.split('|')[0].split('\u2013')[0].trim();

          var price = document.createElement('span');
          price.className = 'jam-wishpage__price';
          var mtxt = money(p.price, page.dataset.currency, locale);
          if (/ AED$/.test(mtxt)) {
            var dhs = document.createElement('span'); dhs.className = 'jam-dhs'; dhs.textContent = 'AED';
            price.textContent = '';
            price.appendChild(dhs);
            price.appendChild(document.createTextNode(' ' + mtxt.slice(0, -4)));
          } else { price.textContent = mtxt; }

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'jam-wishpage__remove';
          remove.setAttribute('data-jam-wish', '');
          remove.dataset.remove = 'true';
          remove.dataset.handle = handle;
          remove.textContent = page.dataset.removeLabel || 'Remove';

          el.appendChild(media); el.appendChild(title); el.appendChild(price); el.appendChild(remove);
          grid.appendChild(el);
          sync();
        })
        .catch(function () { /* product gone \u2014 drop it silently */
          var l = read(), i = l.indexOf(handle);
          if (i > -1) { l.splice(i, 1); write(l); }
        });
    });
  }
  document.addEventListener('DOMContentLoaded', renderPage);

  window.jamWishlist = { read: read, toggle: toggle, sync: sync };
})();
